<template>
  <canvas
    ref="canvas"
    :width="width"
    :height="height"
    :style="{ background: canvasBackground }"
    @pointerdown="startDrawing"
    @pointermove="continueDrawing"
    @pointerup="finishDrawing"
    @pointercancel="finishDrawing"
  />
</template>

<script>
export default {
  name: "ResponsiveSignaturePad",
  props: {
    width: { type: Number, default: 800 },
    height: { type: Number, default: 300 },
    lineWidth: { type: Number, default: 2 },
    lineColor: { type: String, default: "#000000" },
    bgColor: { type: String, default: "" },
    isCrop: { type: Boolean, default: false },
  },
  data() {
    return {
      canvasTxt: null,
      hasDrew: false,
      isDrawing: false,
      points: [],
      lastPoint: null,
    };
  },
  computed: {
    canvasBackground() {
      return this.bgColor || "rgba(255, 255, 255, 0)";
    },
  },
  mounted() {
    this.canvasTxt = this.$refs.canvas.getContext("2d");
  },
  methods: {
    canvasPoint(event) {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvas.width) / rect.width,
        y: ((event.clientY - rect.top) * canvas.height) / rect.height,
      };
    },
    applyStrokeStyle() {
      const rect = this.$refs.canvas.getBoundingClientRect();
      const displayScale = rect.width ? this.$refs.canvas.width / rect.width : 1;
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * displayScale;
      this.canvasTxt.lineCap = "round";
      this.canvasTxt.lineJoin = "round";
    },
    startDrawing(event) {
      event.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      this.lastPoint = this.canvasPoint(event);
      this.points.push(this.lastPoint);
      if (event.currentTarget.setPointerCapture) {
        event.currentTarget.setPointerCapture(event.pointerId);
      }
    },
    continueDrawing(event) {
      if (!this.isDrawing) return;
      event.preventDefault();
      const point = this.canvasPoint(event);
      this.applyStrokeStyle();
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.lastPoint.x, this.lastPoint.y);
      this.canvasTxt.lineTo(point.x, point.y);
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.lastPoint = point;
      this.points.push(point);
    },
    finishDrawing(event) {
      if (!this.isDrawing) return;
      event.preventDefault();
      this.isDrawing = false;
      this.lastPoint = null;
      this.points.push({ x: -1, y: -1 });
      if (
        event.currentTarget.releasePointerCapture &&
        event.currentTarget.hasPointerCapture(event.pointerId)
      ) {
        event.currentTarget.releasePointerCapture(event.pointerId);
      }
    },
    generate() {
      return new Promise((resolve, reject) => {
        if (!this.hasDrew) {
          reject(new Error("Not Signed"));
          return;
        }

        try {
          resolve(this.$refs.canvas.toDataURL("image/png"));
        } catch (error) {
          reject(error);
        }
      });
    },
    reset() {
      const canvas = this.$refs.canvas;
      this.canvasTxt.clearRect(0, 0, canvas.width, canvas.height);
      this.points = [];
      this.hasDrew = false;
      this.isDrawing = false;
      this.lastPoint = null;
      this.$emit("update:bgColor", "");
    },
  },
};
</script>

<style scoped>
canvas {
  display: block;
  touch-action: none;
  user-select: none;
}
</style>
